import { LoadState } from "../../../constants/enums";

export interface IGLMonthlySummary {
  fiscal_years_code: string | null;
  fiscal_year_month_code: string | null;
  year: string | null;
  period: string | null;
  period_from: string | null;
  period_to: string | null;
  branch_code: string | null;
  gl_account_id: string | null;
  gl_account_code: string | null;
  gl_account_name: string | null;
  gl_account_type: string | null;
  balance_sheet_or_income_statement_account: string | null;
  opening_debit: number | null;
  opening_credit: number | null;
  period_debit: number | null;
  period_credit: number | null;
  closing_debit: number | null;
  closing_credit: number | null;
  ytd_debit: number | null;
  ytd_credit: number | null;
  re_rollforward_debit: number | null;
  re_rollforward_credit: number | null;
  entry_count: number | null;
  source_checksum: string | null;
  status: string | null;
}

export interface IGLMonthlySummaryState {
  list: IGLMonthlySummary[];
  loading: LoadState;
  totalRecords: number;
  error: string | null;
}

export const initialGLMonthlySummaryState: IGLMonthlySummaryState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  error: null,
};
